import React from 'react';
import { Link } from 'react-router-dom';

import '../styles/sign-up-success.scss';
import cbcvLogo from '../assets/logo2016cuadrado_sinfondo.png';

const SignUpSuccessPage = () => (
  <div id="sign-up-success">
    <img alt="logo" src={cbcvLogo} />
    <div>
      <h4>
        <i className="material-icons">check_circle</i>
        Tu solicitud de cuenta ha sido enviada
      </h4>
      <p> Una vez que un administrador active su cuenta será notificado por mail y podrá acceder. </p>
      <Link to="/"> Volver al inicio </Link>
    </div>
  </div>
);

export default SignUpSuccessPage;



// WEBPACK FOOTER //
// ./src/containers/SignUpSuccessPage.js